import { render, staticRenderFns } from "./SubTaskFrame.vue?vue&type=template&id=65b64f66"
import script from "./SubTaskFrame.vue?vue&type=script&lang=js"
export * from "./SubTaskFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports